var map = {
	"./arrow-right-news.svg": "6bbb",
	"./arrow-top.svg": "d162",
	"./booking.svg": "ada7",
	"./calendar.svg": "b8bd",
	"./clock.svg": "755b",
	"./close.svg": "8b1b",
	"./down-arrow.svg": "fcc4",
	"./facebook-flat.svg": "4404",
	"./filter.svg": "2376",
	"./grid.svg": "4b05",
	"./inresize.svg": "9242",
	"./left-arrow-back.svg": "e385",
	"./left-arrow-neo.svg": "1817",
	"./left-arrow.svg": "6d4b",
	"./list.svg": "99ad",
	"./mail.svg": "3ae9",
	"./mobile.svg": "0df4",
	"./pdf-download.svg": "4b3b",
	"./pdf.svg": "5730",
	"./phone.svg": "c3bb",
	"./pin-map.svg": "f5bd",
	"./pin.svg": "862b",
	"./plane.svg": "5a4b",
	"./play.svg": "dab1",
	"./print.svg": "671e",
	"./resize-gal.svg": "ded6",
	"./right-arrow-neo.svg": "1774",
	"./right-arrow.svg": "c686",
	"./telegram-flat.svg": "4d99",
	"./telegram.svg": "2b29",
	"./unresize.svg": "9546",
	"./video.svg": "512b",
	"./whatsapp-flat.svg": "330d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";